import classNames from 'classnames';

import React, {
  forwardRef,
  ForwardRefExoticComponent,
  HTMLAttributes,
  ReactNode,
  RefAttributes,
} from 'react';

import { Content } from '../content';
import { SectionHeading } from '../section-heading';
import { Typography } from '../typography';

import styles from './list-view.scss';

type ListViewProps = RefAttributes<HTMLDivElement> &
  HTMLAttributes<HTMLDivElement> & {
    header?: string | ReactNode;
    headerNoPadding?: boolean;
    footer?: string;
    divider?: boolean;
    dataTestId?: string;
  };

const COMPONENT_ID = 'modulor-list-view';

export const ListView: ForwardRefExoticComponent<ListViewProps> = forwardRef<
  HTMLDivElement,
  ListViewProps
>(
  (
    {
      dataTestId = COMPONENT_ID,
      header,
      headerNoPadding,
      footer,
      divider = false,
      children,
      className,
      ...rest
    },
    ref,
  ) => {
    return (
      <div
        className={classNames(className, styles.root, {
          [styles.divider]: divider,
        })}
        data-testid={dataTestId}
        data-id={dataTestId}
        data-component-name={COMPONENT_ID}
        ref={ref}
        {...rest}>
        {typeof header === 'string' ? (
          <SectionHeading dataTestId={`${dataTestId}-header`} noPadding={headerNoPadding}>
            <Content text={header} variant="caption-1-regular-caps" />
            <Content />
          </SectionHeading>
        ) : (
          header
        )}
        <ul className={styles.list} data-testid={`${dataTestId}-list`}>
          {children}
        </ul>
        {footer && (
          <div className={styles.footer} data-testid={`${dataTestId}-footer`}>
            <Typography variant="caption-1-regular">{footer}</Typography>
          </div>
        )}
      </div>
    );
  },
);

ListView.displayName = 'ListView';
